module.exports = __webpack_public_path__ + "img/123.42c28286.jpg";